import React from 'react';
import './Loader.css';
import LoaderImage from '../assets/images/loader.gif';

const Loader = () => {
  return (
    <div className='loading' role="status" aria-label="Loading content">
      <img src={LoaderImage} alt="Loading..." width="80" height="80" />
    </div>
  );
};

export default Loader;
